import * as React from 'react';
import { Location } from 'lib/componentLocation';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { AddPortCall, AddPortCallParams } from './model';
import { AddPortCallView } from './view';
import TZDate from 'lib/TZDate';

export const AddPortCallRoute = (model : (params : AddPortCallParams) => AddPortCall, appWrapper : AppWrapper, request : Location) => ({
    view:
        <AppWrapperView model={appWrapper}>
            <AddPortCallView model={model(convertParams(request))} />
        </AppWrapperView>
});

function convertParams(request : Location) : AddPortCallParams {
    const p = request.params;
    return {
        firstLine:
            p['firstline'] ? new TZDate(p['firstline']) :
            p['arrival'  ] ? new TZDate(p['arrival'  ]) :
            undefined,
        lastLine:
            p['lastline' ] ? new TZDate(p['lastline' ]) :
            p['departure'] ? new TZDate(p['departure']) :
            undefined,
        footmark: p['footmark'] ? +p['footmark'] : undefined,
        berth: p['berth'] ? +p['berth'] : undefined
    };
}



// WEBPACK FOOTER //
// ./apps/portcall/addportcall/route.tsx